import apiService from "./ApiService"
import { createQS } from "./Utils"

class CameraService {
  async get(idCruzamento) {
    try {
      const qs = createQS({ idCruzamento })
      return await apiService.get(`camera?${qs}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getById(id) {
    try {
      return await apiService.get(`camera/${id}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async create(data) {
    try {
      return await apiService.post(`camera`, data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async update(id, data) {
    try {
      return await apiService.put(`camera/${id}`, data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async delete(id) {
    try {
      return await apiService.delete(`camera/${id}`)
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
}

const cameraService = new CameraService()
export default cameraService